<template>
  <div class="app-main-content ai-reconciliation">
    <div class="tabs-container">
      <el-tabs
        v-model="activeTab"
        type="card"
        style="width:100%;"
        @tab-remove="handleTabRemove"
      >
        <el-tab-pane
          v-for="tab in tabs"
          :key="tab.name"
          :label="tab.label"
          :name="tab.name"
          :closable="tab.closable"
        >
          <component
            :is="tab.component"
            :task-id="tab.taskId"
            :refresh-key="tab.refreshKey"
            @create-task="openCreateTab"
            @view-task="openTaskTab"
            @back="backToBoard"
            @created="handleTaskCreated"
            @open-compare="openCompareTab"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import TabLogisticsBillImport from './components/tabLogisticsBillImport'
import TabAiMatch from './components/tabAiMatch'
import TabReconciliationResult from './components/tabReconciliationResult'
import TabReconciliationHistory from './components/tabReconciliationHistory'

export default {
  name: 'AIReconciliation',
  components: {
    TabLogisticsBillImport,
    TabAiMatch,
    TabReconciliationResult,
    TabReconciliationHistory
  },
  data() {
    return {
      // 看板常驻、不可关；其余 tab 按需打开、可关闭
      tabs: [
        {
          name: 'board',
          label: '对账看板',
          component: TabLogisticsBillImport,
          closable: false,
          refreshKey: 0
        }
      ],
      activeTab: 'board'
    }
  },
  methods: {
    // 打开/激活「新建任务」tab（全局唯一，重复点创建不重复开）
    openCreateTab() {
      this.ensureTab({
        name: 'create',
        label: '新建任务',
        component: TabAiMatch,
        closable: true
      })
    },
    // 打开/激活「任务详情」tab（按任务编号，同任务不重复开，不同任务各开一个）
    openTaskTab(row) {
      const taskNo = row && row.taskNo
      const taskUuid = row && row.taskUuid
      if (!taskUuid) return
      this.ensureTab({
        name: `task:${taskNo}`,
        label: `任务详情·${taskNo}`,
        component: TabReconciliationResult,
        taskId: taskUuid,
        closable: true
      })
    },
    // 打开/激活「对比详情」tab（按任务编号，同任务不重复开）
    // 由「任务详情」底部入口触发：this.$emit('open-compare', { taskUuid, taskNo })
    openCompareTab(payload) {
      const taskId = typeof payload === 'string' ? payload : payload && payload.taskUuid
      const taskNo = typeof payload === 'string' ? payload : payload && payload.taskNo
      if (!taskId) return
      this.ensureTab({
        name: `compare:${taskId}`,
        label: `对比详情·${taskNo || taskId}`,
        component: TabReconciliationHistory,
        taskId,
        closable: true
      })
    },
    // 新建任务「取消/提交成功」→ 回看板（保留新建 tab，草稿不丢，由用户手动关闭）
    backToBoard() {
      this.activeTab = 'board'
    },
    // 创建成功后切回看板，并通知已挂载的看板重新请求任务列表
    handleTaskCreated() {
      const boardTab = this.tabs.find(tab => tab.name === 'board')
      if (boardTab) {
        boardTab.refreshKey += 1
      }
      this.activeTab = 'board'
    },
    // 新 tab 首次打开则 push，已存在则直接激活
    ensureTab(tab) {
      const exists = this.tabs.find(t => t.name === tab.name)
      if (!exists) {
        this.tabs.push(tab)
      }
      this.$nextTick(() => {
        this.activeTab = tab.name
      })
    },
    handleTabRemove(name) {
      // 看板不可关闭
      if (name === 'board') return
      const idx = this.tabs.findIndex(t => t.name === name)
      if (idx === -1) return
      this.tabs.splice(idx, 1)
      // 关的是当前激活的 tab → 回到看板
      if (this.activeTab === name) {
        this.activeTab = 'board'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ai-reconciliation {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden !important;
}

.tabs-container {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

::v-deep .el-tabs {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

::v-deep .el-tabs__header {
  flex-shrink: 0;
}

::v-deep .el-tabs__content {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

::v-deep .el-tab-pane {
  height: 100%;
  min-height: 0;
  overflow: hidden;
}
</style>
